import api from './index'
class Product {
    getProductByProduct(product){
        return api.get('/product/'+product)
    }
}
export default new Product()